import React from "react";

const IconBounce: React.FC = () => {
	return (
		<svg
			id="Layer_1"
			xmlns="http://www.w3.org/2000/svg"
			viewBox="0 0 76.82 69.46"
			stroke="currentColor"
			fill="none"
			strokeWidth={6}
		>
			<path
				className="cls-1"
				d="m73.82,3s-.99,6.29-5.83,6.29-6.12-6.29-6.12-6.29c0,0-.17,16.67-8.28,16.67-6.51,0-7.67-16.67-7.67-16.67,0,0,.67,30.97-8.99,30.97S28.46,3,28.46,3c0,0,.09,63.46-12.58,63.46S3,3,3,3"
			/>
		</svg>
	);
};

export default IconBounce;
